module.exports = __webpack_public_path__ + "static/media/bubble-blocked.84d5e748.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/bubble-blocked.svg
// module id = 2459
// module chunks = 7